<template>
  <div class="main">
    <div class="main_Banner">
      <swiper :options="swiperBanner" class="banner_swiper">
        <swiper-slide v-for="(item, index) in bannerList" :key="index">
          <!-- <img src="../assets/pcImg/main_banner.jpg" alt /> -->
          <img :src="item.img_url" alt />
        </swiper-slide>

        <!-- <swiper-slide>
                    <img src="../assets/pcImg/main_banner.jpg" alt />
                    <div class="know_more">
                        <div class="more_btn" v-on:click="gotogame()">{{$t('m.home.moregame')}}</div>
                    </div>
        </swiper-slide>-->
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
      <div class="know_more">
        <div class="more_btn" v-on:click="gotogame()">{{ $t("m.home.moregame") }} &nbsp;></div>
      </div>
    </div>
    <div class="main_body">
      <img src="../assets/pcImg/main_bg.jpg" alt />
      <div class="presentation">
        <div class="company_information">
          <div class="title">
            <img src="../assets/pcImg/index_news_title.png" alt />
            <span>{{ $t("m.home.gameintro") }}</span>
          </div>
          <img src="../assets/pcImg/home/newMan.png" alt class="leftMan" />
          <div class="right_dom animate__animated animate__fadeInUp animate__delay-03s">
            <!-- <div class="line_gradient"></div> -->
            <img src="../assets/pcImg/home/newbg.png" alt class="new_bg" />
            <div class="goto_more" @click="goMore">更多 ></div>
            <ul>
              <li v-for="(item, index) in homeNewsList" :key="index">
                <router-link :to="'/newsDetail/' + item.id">
                  <span class="new_title">
                    <span v-if="item.type" class="news_type">{{ item.type }}</span>
                    {{ item.title }}
                  </span>
                  <span class="new_date">
                    {{
                    item.release_time | formatDate
                    }}
                  </span>
                </router-link>
              </li>
            </ul>
          </div>
        </div>
        <!-- 移出公司游戏模块 -->
        <!-- <div class="company_game">
                    <div class="title">公司游戏</div>
                    <swiper :options="swiperGameList" class="game_list">
                        <swiper-slide class="game_item">
                            <div class="game_img">
                                <img src="../assets/pcImg/home/hunter.png" alt />
                            </div>
                            <p class="game_name">Hunter X Hunter猎人</p>
                        </swiper-slide>
                        <swiper-slide class="game_item">
                            <div class="game_img">
                                <img src="../assets/pcImg/home/xsg.png" alt />
                            </div>
                            <p class="game_name">新三国汉室复兴</p>
                        </swiper-slide>
                        <swiper-slide class="game_item">
                            <div class="game_img">
                                <img src="../assets/pcImg/home/codeseed.png" alt />
                            </div>
                            <p class="game_name">CodeSeed:星火之歌</p>
                        </swiper-slide>
                        <swiper-slide class="game_item">
                            <div class="game_img">
                                <img src="../assets/pcImg/home/xxzg.png" alt />
                            </div>
                            <p class="game_name">小小主公2</p>
                        </swiper-slide>
                        <swiper-slide class="game_item">
                            <div class="game_img">
                                <img src="../assets/pcImg/home/tfsgz.png" alt />
                            </div>
                            <p class="game_name">塔防三国志</p>
                        </swiper-slide>
                        <swiper-slide class="game_item">
                            <div class="game_img">
                                <img src="../assets/pcImg/home/ldyxz.png" alt />
                            </div>
                            <p class="game_name">乱斗英雄志</p>
                        </swiper-slide>
                        <swiper-slide class="game_item">
                            <div class="game_img">
                                <img src="../assets/pcImg/home/wpzpr.png" alt />
                            </div>
                            <p class="game_name">王牌制片人</p>
                        </swiper-slide>
                        <swiper-slide class="game_item">
                            <div class="game_img">
                                <img src="../assets/pcImg/home/zgkcp.png" alt />
                            </div>
                            <p class="game_name">主公快出牌</p>
                        </swiper-slide>
                    </swiper>

                    <div class="swiper-button-next"></div>
                    <div class="swiper-button-prev"></div>
        </div>-->

        <div class="company_intrduce">
          <div class="company_title">
            <img src="../assets/pcImg/index_com_title.png" alt />
            <span>{{ $t("m.home.companyintro") }}</span>
          </div>
          <div class="company_content">{{ $t("m.home.aboutcompany") }}</div>
          <div class="more_btn" v-on:click="gotoCompany()">{{ $t("m.home.moredetail") }} &nbsp;></div>
          <img src="../assets/pcImg/home/map.png" alt class="map" />
          <div class="suzhou_company tooltip-west tooltip tooltip_show">
            <!-- <div class="bg_img sharing"></div> -->
            <img src="../assets/pcImg/logo_n.png" alt class="logo_else" />
            <div class="wave ripple else-pos">
              <div class="circle"></div>
              <div class="circle"></div>
              <div class="circle"></div>
            </div>
            <span class="font-area">{{$t("m.home.sz")}}</span>
            <!-- <span class="tooltip-content">{{
                            $t("m.home.sz")
            }}</span>-->
          </div>
          <div class="taiwan_company tooltip-west tooltip-small tooltip else-logo">
            <div class="bg_img"></div>
            <img src="../assets/pcImg/home/mapicon.png" alt />
            <div class="wave ripple">
              <div class="circle"></div>
              <div class="circle"></div>
              <div class="circle"></div>
            </div>
            <span class="tooltip-content">
              {{
              $t("m.home.tw")
              }}
            </span>
          </div>
          <div class="xianggang_company tooltip-west tooltip-small tooltip else-logo">
            <div class="bg_img"></div>
            <img src="../assets/pcImg/home/mapicon.png" alt />
            <div class="wave ripple">
              <div class="circle"></div>
              <div class="circle"></div>
              <div class="circle"></div>
            </div>
            <span class="tooltip-content">
              {{
              $t("m.home.xg")
              }}
            </span>
          </div>
          <div class="shouer_company tooltip-west tooltip-small tooltip else-logo">
            <div class="bg_img"></div>
            <img src="../assets/pcImg/home/mapicon.png" alt />
            <div class="wave ripple">
              <div class="circle"></div>
              <div class="circle"></div>
              <div class="circle"></div>
            </div>
            <span class="tooltip-content">{{$t("m.home.kr")}}</span>
          </div>
          <div class="shanghai_company tooltip-west tooltip-small tooltip else-logo">
            <div class="bg_img"></div>
            <img src="../assets/pcImg/home/mapicon.png" alt />
            <div class="wave ripple">
              <div class="circle"></div>
              <div class="circle"></div>
              <div class="circle"></div>
            </div>
            <span class="tooltip-content">
              {{
              $t("m.home.sh")
              }}
            </span>
          </div>
          <div class="hainan_company tooltip-west tooltip-small tooltip else-logo">
            <div class="bg_img"></div>
            <img src="../assets/pcImg/home/mapicon.png" alt />
            <div class="wave ripple">
              <div class="circle"></div>
              <div class="circle"></div>
              <div class="circle"></div>
            </div>
            <span class="tooltip-content">
              {{
              $t("m.home.hn")
              }}
            </span>
          </div>
          <div class="xinjiapo_company tooltip-west tooltip-small tooltip else-logo">
            <div class="bg_img"></div>
            <img src="../assets/pcImg/home/mapicon.png" alt />
            <div class="wave ripple">
              <div class="circle"></div>
              <div class="circle"></div>
              <div class="circle"></div>
            </div>
            <span class="tooltip-content xinjiapo_width">
              {{
              $t("m.home.xjp")
              }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <loading v-if="loading" class="loading"></loading>
  </div>
</template>

<script>
import Loading from './loading'
import { formatDate } from '@/assets/js/date.js'
export default {
  components: {
    Loading,
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 30,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      swiperBanner: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },
      swiperGameList: {
        slidesPerView: 5,
        spaceBetween: 15,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        loop: true,
      },
      proList: [],
      bannerList: [],
      homeNewsList: [],
      loading: true,
    }
  },
  filters: {
    formatDate: function (time) {
      var date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd')
    },
  },
  computed: {
    getUserLangs() {
      return this.$i18n.locale
    },
  },
  watch: {
    getUserLangs(val) {
      this.markPost(this.$i18n.locale)
    },
  },
  mounted: function () {
    this.markPost(this.$i18n.locale)
    this.getBannerList()
    this.getHomeNewsList()
  },
  methods: {
    gotogame() {
      this.$router.push({ path: '/produce' })
    },
    gotoCompany() {
      this.$router.push({ path: '/aboutUs' })
    },
    gotoJoin() {
      this.$router.push({ path: '/recruitment' })
    },
    goMore() {
      this.$router.push({ path: '/news' })
    },
    markPost(e) {
      let datas = {
        lang: e,
      }
      let datasTwo = {
        lang: e,
        img: 4,
      }
      this.getHttp(this, datas, '/front/product', function (obj, data) {
        obj.proList = data
      })
    },
    getBannerList() {
      let datas = {}
      this.getHttp(this, datas, '/front/home/banner', function (obj, data) {
        if (data.status == 2000) {
          obj.bannerList = data.data
        }
        obj.loading = false
      })
    },
    getHomeNewsList() {
      let datas = {}
      this.getHttp(this, datas, '/front/home/news', function (obj, data) {
        if (data.status == 2000) {
          obj.homeNewsList = data.data
        }
      })
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.else-pos {
  bottom: 0.04rem !important;
  margin-left: -0.36rem !important;
}
a {
  text-decoration: none;
}
.font-area {
  font-size: 0.1rem;
  color: #00ffff;
  width: 0.8rem;
  display: inline-block;
  position: absolute;
  top: -0.16rem;
  left: -0.1rem;
}
.logo_else {
  width: 0.4rem;
  height: 0.56rem;
}
.else-logo img {
  width: 0.19rem;
  height: 0.26rem;
}
.loading {
  position: fixed;
  top: 50%;
  z-index: 9999;
}
.main_Banner {
  width: 100%;
  height: 0;
  padding-bottom: 52.084%;
  position: relative;
  background: #1d222c;
  .banner_swiper {
    height: 10rem;
  }
  .swiper-pagination {
    bottom: 50px;
    height: 50px;
    line-height: 0;
  }
}
.know_more {
  width: 12rem;
  position: absolute;
  left: 50%;
  margin-left: -6rem;
  bottom: 1rem;
  z-index: 9999;
  .more_btn {
    float: right;
    width: 2.0508rem;
    height: 0.545rem;
    line-height: 0.49rem;
    border-radius: 0.2725rem;
    border: 0.02rem solid #00ffff;
    box-sizing: border-box;
    color: #00ffff;
    font-size: 0.2rem;
    text-align: center;
    cursor: pointer;
    &:hover {
      color: white;
      background: rgba(0, 255, 255, 0.65);
      transition: background ease-out 0.7s;
    }
  }
}
.main_body {
  position: relative;
  width: 100%;
  overflow-x: hidden;
  .title {
    width: 4rem;
    position: absolute;
    top: 0.53rem;
    text-align: center;
    left: 50%;
    margin-left: -2rem;
    letter-spacing: 0px;
    color: white;
    font-size: 0.45rem;
    font-weight: bold;
    span {
      display: inline-block;
      position: absolute;
      top: 45%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  // .title::after {
  //     content: "";
  //     display: block;
  //     margin-left: 5rem;
  //     margin-top: 0.1rem;
  //     width: 2rem;
  //     height: 2px;
  //     background: linear-gradient(
  //         to right,
  //         rgba(0, 0, 0, 0) 0%,
  //         rgba(0, 0, 0, 0) 10%,
  //         rgba(251, 140, 76, 0.3) 20%,
  //         rgba(251, 140, 76, 0.4) 30%,
  //         rgba(251, 140, 76, 0.5) 40%,
  //         rgba(251, 140, 76, 0.8) 50%,
  //         rgba(251, 140, 76, 0.5) 60%,
  //         rgba(251, 140, 76, 0.4) 70%,
  //         rgba(251, 140, 76, 0.3) 80%,
  //         rgba(0, 0, 0, 0) 90%,
  //         rgba(0, 0, 0, 0) 100%
  //     );
  // }
  .swiper_body {
    width: 12rem;
    position: absolute;
    top: 4rem;
    left: 50%;
    margin-left: -6rem;
    padding: 0 1rem;
    .swiper-slide {
      text-align: center;
    }
    .swiper_img {
      width: 1.87rem;
      height: 1.87rem;
      border-radius: 1.87rem;
    }
    .game_name {
      width: 100%;
      text-align: center;
      font-size: 0.16rem;
      color: white;
      margin-top: 0.2rem;
    }
    .swiper-button-prev,
    .swiper-container-rtl .swiper-button-next {
      background-image: url(../assets/pcImg/prev.png);
      width: 0.5rem;
      height: 0.5rem;
      background-size: 100%;
    }
    .swiper-button-next,
    .swiper-container-rtl .swiper-button-prev {
      background-image: url(../assets/pcImg/next.png);
      width: 0.5rem;
      height: 0.5rem;
      background-size: 100%;
    }
  }
  .company_information {
    width: 100%;
    height: 10rem;
    position: absolute;
    top: 0rem;
    left: 0;
    .leftMan {
      position: absolute;
      width: 6.62rem;
      top: 0.5rem;
      left: 50%;
      margin-left: -7.5rem;
    }
    .right_dom {
      position: absolute;
      width: 12.69rem;
      top: 2.5rem;
      right: 0;
      .line_gradient {
        position: absolute;
        width: 100%;
        height: 0.08rem;
        left: 0;
        bottom: 0;
        background-image: linear-gradient(
          to right,
          #fe8d08,
          #34ee76,
          #00eaff,
          #8400ff
        );
        // background-image:linear-gradient(to right,rgba(254,141,8) 0,rgba(52,238,118) 30%,rgba(0,234,255) 70%, rgba(132,0,255) 100%);
      }
      .goto_more {
        width: 1rem;
        line-height: 0.4rem;
        font-size: 0.2rem;
        color: #00ffff;
        cursor: pointer;
        position: absolute;
        top: 0.45rem;
        left: 7.7rem;
      }
      ul {
        padding: 0;
        margin: 0;
        list-style: 0;
        width: 6.99rem;
        height: 3.6rem;
        overflow: hidden;
        position: absolute;
        top: 0.9rem;
        left: 1.3rem;
        li {
          width: 100%;
          height: 0.6rem;
          box-sizing: border-box;
          border-bottom: 1px dashed #f08200;
          color: white;
          line-height: 0.6rem;
          font-size: 0.2rem;
          cursor: pointer;
          position: relative;
          z-index: 0;
          a {
            color: white;
          }
          .new_title {
            width: 78%;
            display: block;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            -o-text-overflow: ellipsis;
            float: left;
            .news_type {
              display: inline-block;
              margin-right: 0.02rem;
              margin-bottom: 0.055rem;
              padding: 0.01rem 0.07rem;
              line-height: initial;
              font-size: 0.18rem;
              color: #00ffff;
              border: 1px solid #00ffff;
              vertical-align: middle;
              box-sizing: border-box;
            }
          }
          .new_date {
            width: 22%;
            text-align: right;
            display: block;
            float: left;
          }
        }
        li::after {
          width: 0;
          height: 100%;
          content: '';
          background-color: rgba(240, 147, 19, 0.2);
          position: absolute;
          top: 0%;
          left: 50%;
          right: 50%;
          transition: all 0.5s;
          z-index: -1;
        }
        li:hover::after {
          width: 100%;
          left: 0%;
          right: 0%;
        }
      }
    }
  }
  .company_game {
    width: 100%;
    height: 10rem;
    position: absolute;
    top: 9.7rem;
    left: 0;
    .title {
      top: 0;
    }
    .swiper-button-prev {
      width: 0.8rem;
      height: 0.8rem;
      background: url('../assets/pcImg/home/prev.png') no-repeat;
      background-size: 100% 100%;
      outline: none;
      left: 0;
    }
    .swiper-button-next {
      width: 0.8rem;
      height: 0.8rem;
      background: url('../assets/pcImg/home/next.png') no-repeat;
      background-size: 100% 100%;
      outline: none;
      right: 0;
    }
    .game_list {
      width: 12rem;
      height: 4.8rem;
      position: absolute;
      left: 50%;
      margin-left: -6rem;
      top: 2rem;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      -webkit-transform: skewX(-15deg);
      -moz-transform: skewX(-15deg);
      -o-transform: skewX(-15deg);
      -ms-transform: skewX(-15deg);
      transform: skewX(-15deg);
      overflow-y: inherit;
      .game_item {
        width: 2.1rem;
        height: 4.05rem;
        margin-top: 0.75rem;
        text-align: center;
        background: url('../assets/pcImg/home/i_bg2.png') no-repeat;
        background-size: 100% 100%;
        position: relative;
        -webkit-transition: all 0.3s;
        -moz-transition: all 0.3s;
        -o-transition: all 0.3s;
        -ms-transition: all 0.3s;
        transition: all 0.3s;
        cursor: pointer;
        .game_img {
          position: absolute;
          width: 100%;
          bottom: 66px;
          left: 0;
          /* transform: translate(0%, -50%); */
          -webkit-transition: all 0.3s;
          -moz-transition: all 0.3s;
          -o-transition: all 0.3s;
          -ms-transition: all 0.3s;
          transition: all 0.3s;
          img {
            max-width: inherit;
            width: 2.2rem;
            display: block;
            margin-left: -0%;
            -webkit-transform: skewX(15deg);
            -moz-transform: skewX(15deg);
            -o-transform: skewX(15deg);
            -ms-transform: skewX(15deg);
            transform: skewX(15deg);
            -webkit-transition: all 0.3s;
            -moz-transition: all 0.3s;
            -o-transition: all 0.3s;
            -ms-transition: all 0.3s;
            transition: all 0.3s;
            opacity: 0.3;
            filter: Alpha(opacity=30);
          }
        }
        .game_name {
          font-size: 0.18rem;
          color: white;
          text-align: center;
          width: 100%;
          -webkit-transform: skewX(15deg);
          -moz-transform: skewX(15deg);
          -o-transform: skewX(15deg);
          -ms-transform: skewX(15deg);
          transform: skewX(15deg);
          margin: 0;
          padding: 0;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          transition: all 0.3s;
          position: absolute;
          bottom: 0.15rem;
        }
      }
      .game_item:hover {
        width: 2.8rem !important;
        background-image: url('../assets/pcImg/home/i_bg2_on.png');
        z-index: 1;
        .game_img {
          bottom: 42px;
          transform: translate(0%, 0%);
          img {
            max-width: inherit;
            width: 3.8rem;
            margin-left: -0.6rem;
            opacity: 1;
            filter: Alpha(opacity=100);
          }
        }
      }
    }
  }
  .company_intrduce {
    width: 100%;
    height: 7.45rem;
    position: absolute;
    bottom: 0;
    left: 0%;
    overflow: hidden;
    .company_title {
      width: 4rem;
      position: absolute;
      top: 0.53rem;
      text-align: center;
      left: 50%;
      margin-left: -2rem;
      letter-spacing: 0px;
      color: white;
      font-size: 0.45rem;
      font-weight: bold;
      span {
        display: block;
        position: absolute;
        top: 46%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    /*.company_title::after {
            content: "";
            display: block;
            margin-left: -0.3rem;
            margin-top: 0.1rem;
            width: 2rem;
            height: 2px;
            background: linear-gradient(
                to right,
                rgba(0, 0, 0, 0) 0%,
                rgba(0, 0, 0, 0) 10%,
                rgba(251, 140, 76, 0.3) 20%,
                rgba(251, 140, 76, 0.4) 30%,
                rgba(251, 140, 76, 0.5) 40%,
                rgba(251, 140, 76, 0.8) 50%,
                rgba(251, 140, 76, 0.5) 60%,
                rgba(251, 140, 76, 0.4) 70%,
                rgba(251, 140, 76, 0.3) 80%,
                rgba(0, 0, 0, 0) 90%,
                rgba(0, 0, 0, 0) 100%
            );
        }*/
    .map {
      width: 14rem;
      position: absolute;
      bottom: 0;
      right: 1.13rem;
    }
    .company_content {
      position: absolute;
      top: 2.3rem;
      left: 4rem;
      width: 9.8rem;
      height: 1.18rem;
      font-family: PingFang-SC-Regular;
      font-size: 0.18rem;
      font-weight: normal;
      font-stretch: normal;
      line-height: 0.25rem;
      letter-spacing: 0px;
      color: #ffffff;
    }
    .more_btn {
      border: 2px solid #00ffff;
      width: 2.0508rem;
      height: 0.545rem;
      border-radius: 0.2725rem;
      box-sizing: border-box;
      color: #00ffff;
      line-height: 0.49rem;
      font-size: 0.2rem;
      text-align: center;
      // border-radius: 0.28rem;
      text-align: center;
      position: absolute;
      left: 50%;
      top: 50%;
      margin-left: -1.0254rem;
      margin-top: 0.3275rem;
      z-index: 1;
      cursor: pointer;
      &:hover {
        color: white;
        background: rgba(0, 255, 255, 0.65);
        transition: background ease-out 0.7s;
      }
    }
    .suzhou_company {
      width: 0.59rem;
      height: 0.83rem;
      position: absolute;
      top: 2.22rem;
      right: 3.15rem;
      img {
        position: absolute;
        width: 0.3rem;
        height: 0.42rem;
        left: 50%;
        top: 50%;
        margin-left: -0.28rem;
        margin-top: -0.33rem;
      }
      .sharing {
        animation: tranfromS ease infinite 1.5s;
        -webkit-animation-name: tranfromS; /*关键帧名称*/
        -webkit-animation-timing-function: ease; /*动画的速度曲线*/
        -webkit-animation-iteration-count: infinite; /*动画播放的次数*/
        -webkit-animation-duration: 1.5s; /*动画所花费的时间*/
      }
      .bg_img {
        width: 1.3rem;
        height: 1.3rem;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -0.65rem;
        margin-top: -0.65rem;
        border-radius: 1.6rem;
        background-image: radial-gradient(
          white 5%,
          rgba(255, 255, 255, 0.3) 50%,
          rgba(255, 255, 255, 0) 65%
        );
      }
    }
    .shouer_company {
      width: 0.4rem;
      height: 0.54rem;
      position: absolute;
      top: 2.04rem;
      right: 2.1rem;
      img {
        position: absolute;
        top: 0;
      }
      .bg_img {
        display: none;
        width: 1.16rem;
        height: 1.16rem;
        position: absolute;
        left: -0.4rem;
        top: -0.25rem;
        border-radius: 1.16rem;
        background-image: radial-gradient(
          white 5%,
          rgba(255, 255, 255, 0.3) 50%,
          rgba(255, 255, 255, 0) 65%
        );
      }
    }
    // .shouer_company:hover .bg_img,
    // .xianggang_company:hover .bg_img,
    // .taiwan_company:hover .bg_img {
    //   display: block;
    //   animation: tranfromS ease infinite 1.5s;
    //   -webkit-animation-name: tranfromS; /*关键帧名称*/
    //   -webkit-animation-timing-function: ease; /*动画的速度曲线*/
    //   -webkit-animation-iteration-count: infinite; /*动画播放的次数*/
    //   -webkit-animation-duration: 1.5s; /*动画所花费的时间*/
    // }
    @keyframes tranfromS {
      0% {
        transform: scale(1);
      }
      50% {
        transform: scale(1.1);
      }
      100% {
        transform: scale(1);
      }
    }
    .xinjiapo_company {
      width: 0.4rem;
      height: 0.54rem;
      position: absolute;
      top: 5.7rem;
      right: 4.5rem;
      img {
        position: absolute;
        top: 0;
      }
      .bg_img {
        display: none;
        width: 1.16rem;
        height: 1.16rem;
        position: absolute;
        left: -0.4rem;
        top: -0.25rem;
        border-radius: 1.16rem;
        background-image: radial-gradient(
          white 5%,
          rgba(255, 255, 255, 0.3) 50%,
          rgba(255, 255, 255, 0) 65%
        );
      }
    }
    .hainan_company {
      width: 0.4rem;
      height: 0.54rem;
      position: absolute;
      top: 3.95rem;
      right: 3.85rem;
      img {
        position: absolute;
        top: 0;
      }
      .bg_img {
        display: none;
        width: 1.16rem;
        height: 1.16rem;
        position: absolute;
        left: -0.4rem;
        top: -0.25rem;
        border-radius: 1.16rem;
        background-image: radial-gradient(
          white 5%,
          rgba(255, 255, 255, 0.3) 50%,
          rgba(255, 255, 255, 0) 65%
        );
      }
    }
    .shanghai_company {
      width: 0.4rem;
      height: 0.54rem;
      position: absolute;
      top: 2.46rem;
      right: 2.85rem;
      img {
        position: absolute;
        top: 0;
      }
      .bg_img {
        display: none;
        width: 1.16rem;
        height: 1.16rem;
        position: absolute;
        left: -0.4rem;
        top: -0.25rem;
        border-radius: 1.16rem;
        background-image: radial-gradient(
          white 5%,
          rgba(255, 255, 255, 0.3) 50%,
          rgba(255, 255, 255, 0) 65%
        );
      }
    }
    .xianggang_company {
      width: 0.4rem;
      height: 0.54rem;
      position: absolute;
      top: 3.6rem;
      right: 3.4rem;
      img {
        position: absolute;
        top: 0;
      }
      .bg_img {
        display: none;
        width: 1.16rem;
        height: 1.16rem;
        position: absolute;
        left: -0.4rem;
        top: -0.25rem;
        border-radius: 1.16rem;
        background-image: radial-gradient(
          white 5%,
          rgba(255, 255, 255, 0.3) 50%,
          rgba(255, 255, 255, 0) 65%
        );
      }
    }
    .taiwan_company {
      width: 0.4rem;
      height: 0.54rem;
      position: absolute;
      top: 3.5rem;
      right: 2.8rem;
      img {
        position: absolute;
        top: 0;
      }
      .bg_img {
        display: none;
        width: 1.16rem;
        height: 1.16rem;
        position: absolute;
        left: -0.4rem;
        top: -0.25rem;
        border-radius: 1.16rem;
        background-image: radial-gradient(
          white 5%,
          rgba(255, 255, 255, 0.3) 50%,
          rgba(255, 255, 255, 0) 65%
        );
      }
    }
    .wave {
      position: absolute;
      width: 0.5rem;
      height: 0.3rem;
      text-align: center;
      bottom: 0;
      left: 50%;
      margin-left: -0.335rem;
    }

    .wave .circle {
      position: absolute;
      border-radius: 50%;
      opacity: 0;
    }

    /* 波纹效果 */
    .wave.ripple .circle {
      width: calc(100% - 6px); /* 减去边框的大小 */
      height: calc(100% - 6px); /* 减去边框的大小 */
      border: 3px solid #fff;
      background: rgba(255, 255, 255, 0.4);
    }

    .wave.ripple .circle:first-child {
      animation: circle-opacity 2s infinite;
    }

    .wave.ripple .circle:nth-child(2) {
      animation: circle-opacity 2s infinite;
      animation-delay: 0.3s;
    }

    .wave.ripple .circle:nth-child(3) {
      animation: circle-opacity 2s infinite;
      animation-delay: 0.6s;
    }
    @keyframes circle-opacity {
      from {
        opacity: 1;
        transform: scale(0);
      }
      to {
        opacity: 0;
        transform: scale(1);
      }
    }
  }
  .join_us {
    width: 12.57rem;
    height: 5.57rem;
    position: absolute;
    top: 20.06rem;
    left: 50%;
    margin-left: -6.285rem;
    .join_title {
      width: 5rem;
      top: 0.5rem;
      color: white;
      font-size: 0.36rem;
      position: absolute;
      text-align: left;
      left: 0.5rem;
      letter-spacing: 0px;
    }
    .join_title::after {
      content: '';
      display: block;
      margin-left: -0.3rem;
      margin-top: 0.1rem;
      width: 3.5rem;
      height: 2px;
      background: linear-gradient(
        to right,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0) 10%,
        rgba(251, 140, 76, 0.3) 20%,
        rgba(251, 140, 76, 0.4) 30%,
        rgba(251, 140, 76, 0.5) 40%,
        rgba(251, 140, 76, 0.8) 50%,
        rgba(251, 140, 76, 0.5) 60%,
        rgba(251, 140, 76, 0.4) 70%,
        rgba(251, 140, 76, 0.3) 80%,
        rgba(0, 0, 0, 0) 90%,
        rgba(0, 0, 0, 0) 100%
      );
    }
    .join_content {
      position: absolute;
      top: 1.8rem;
      left: 0.5rem;
      width: 6.5rem;
      height: 1.18rem;
      font-family: PingFang-SC-Regular;
      font-size: 0.18rem;
      font-weight: normal;
      font-stretch: normal;
      line-height: 0.32rem;
      letter-spacing: 0px;
      color: #ffffff;
    }
    .more_btn {
      border: 2px solid #f08200;
      width: 1.44rem;
      height: 0.56rem;
      color: white;
      line-height: 0.56rem;
      font-size: 0.16rem;
      border-radius: 0.28rem;
      text-align: center;
      position: absolute;
      left: 0.5rem;
      top: 4.5rem;
      cursor: pointer;
    }
  }
}
/*.tooltip-content {
    position: absolute;
    background-image: linear-gradient(#3099f3, #3b5de6);
    background-image: linear-gradient(#f3b013, #f08200);
    z-index: 9999;
    width: 130px;
    bottom: 50%;
    margin-bottom: -2em;
    padding: 15px 0;
    border-radius: 8px;
    font-size: 18px;
    text-align: center;
    color: #fff;
    opacity: 0;
    cursor: default;
    pointer-events: none;
    -webkit-font-smoothing: antialiased;
    -webkit-transition: opacity 0.3s, -webkit-transform 0.3s;
    transition: opacity 0.3s, transform 0.3s;
}*/
.tooltip-content {
  font-size: 0.1rem;
  color: #00ffff;
  width: 0.35rem;
  display: inline-block;
  position: absolute;
  top: -0.25rem;
  opacity: 0;
  left: -0.04rem;
  transition: all 0.9s;
}
.xinjiapo_width {
  width: 0.5rem !important;
  left: -0.1rem !important;
}
.tooltip-west .tooltip-content {
  /* left: 5em;
    -webkit-transform-origin: -2em 50%;
        transform-origin: -2em 50%;
        -webkit-transform: translate3d(0, 50%, 0) rotate3d(1, 1, 1, 30deg);
        transform: translate3d(0, 50%, 0) rotate3d(1, 1, 1, 30deg);*/
}
.tooltip-small .tooltip-content {
  /*left: 4em;*/
  margin-bottom: -1em;
}
.tooltip:hover .tooltip-content,
.tooltip_show .tooltip-content {
  opacity: 1;
  -webkit-transform: translate3d(0, 20%, 0) rotate3d(0, 0, 0, 0);
  transform: translate3d(0, 20%, 0) rotate3d(0, 0, 0, 0);
  pointer-events: auto;
}
.tooltip-content::before,
.tooltip-content::after {
  content: '';
  position: absolute;
}
.tooltip-content::before {
  height: 100%;
  width: 3em;
}
.tooltip-west .tooltip-content::before,
.tooltip-west .tooltip-content::after {
  right: 99%;
}
/*.tooltip-content::after {
    width: 2em;
    height: 1em;
    top: 50%;
    margin: -1em 0 0;
    background: url(../assets/pcImg/home/tooltip.png) no-repeat center center;
    background-size: 100%;
}*/
</style>
